function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.5 0.5H3.5C2.945 0.5 2.5 0.95 2.5 1.5V6.5C2.5 7.05 2.945 7.5 3.5 7.5H8.5C9.05 7.5 9.5 7.05 9.5 6.5V1.5C9.5 0.95 9.05 0.5 8.5 0.5ZM0.5 3.5H1.5V2.5H0.5V3.5ZM0.5 5.5H1.5V4.5H0.5V5.5ZM0.5 7.5H1.5V6.5H0.5V7.5ZM1.5 8.5V9.5C0.945 9.5 0.5 9.05 0.5 8.5H1.5ZM7.5 9.5H6.5V8.5H7.5V9.5ZM3.5 6.5H8.5V1.5H3.5V6.5ZM4.5 9.5H5.5V8.5H4.5V9.5ZM3.5 9.5H2.5V8.5H3.5V9.5Z"
});

var SvgFlipToFront = function SvgFlipToFront(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlipToFront, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flip_to_front.90edae31.svg";
export { ForwardRef as ReactComponent };